'use client';

import { cn } from '@newfront-insurance/core-ui/v2';
import { motion } from 'framer-motion';

interface Props {
  show: boolean;
}
export function ThinkingMessage({ show }: Props) {
  if (!show) return null;

  const role = 'assistant';

  return (
    <motion.div
      data-testid="message-assistant-loading"
      className="group/message mx-auto w-full max-w-3xl px-8"
      data-role={role}
    >
      <div
        className={cn(
          'flex w-full items-center gap-4 rounded-lg',
          'group-data-[role=user]/message:ml-auto group-data-[role=user]/message:w-fit',
          'group-data-[role=user]/message:max-w-3xl group-data-[role=user]/message:px-3',
          'group-data-[role=user]/message:bg-muted group-data-[role=user]/message:py-2',
        )}
      >
        <div className="flex items-center gap-2">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="bg-steel-200 size-2 rounded-full"
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 0.5 }}
              transition={{
                repeat: Infinity,
                repeatType: 'reverse',
                duration: 0.8,
                delay: i * 0.2,
                ease: 'easeInOut',
              }}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
}
